import React from 'react';
import { formatTranslation } from 'intl';
import { ProjectSetupTranslationKeys } from 'intl/keys';
import { useBacktrack } from 'components/common/withBacktrack';
import { composeHOCs } from 'shared/utils/composeHOCs';
import { withProcessesData } from 'components/common/withProcessesData';
import { MemoLongCompanyForm } from 'components/company/Form';
import { Spinner } from 'components/core';
import {
  useEditCompany,
  withEditCompany,
} from 'components/dataCreationForms/company/withEditCompany';
import { WithInputForm } from 'components/dataCreationForms/withInputForm';
import { useFormCleanupOnUnmount } from 'presentation/dialogForms/dialogFormsHooks';
import { useCallback, memo } from 'react';
import { useIntl } from 'react-intl';
import { CompanyWizardPage } from '../presentational';
import { withCreateSite } from 'components/dataCreationForms/site/withCreateSite';

function EditCompanyWizardContainer(): React.ReactElement {
  const {
    submitForm,
    isPosting,
    existingValues,
    releaseSubmitEvent,
    SUBMIT_EVENT_TYPE,
    handleFormValidation,
    disableInvolvement,
    validate,
    availableSites,
  } = useEditCompany();
  const intl = useIntl();

  const { back } = useBacktrack();
  const formName = 'company';
  useFormCleanupOnUnmount(formName);
  const onCancel = useCallback(() => {
    back();
  }, [back]);
  if (!existingValues) {
    return (
      <Spinner
        reason='EditCompanyWizardContainer waiting for existing values'
      />
    );
  }
  return (
    <WithInputForm
      key={`${existingValues._id}-${existingValues.sites.map((site) => site._id).join(',')}`}
      values={existingValues}
      errors={{}}
      handleFormValidation={handleFormValidation}
      handleFieldValidation={validate}
      onSubmit={submitForm}
      eventType={SUBMIT_EVENT_TYPE}
      dispatchSubmit={releaseSubmitEvent}
      formName={formName}
    >
      <CompanyWizardPage
        title={formatTranslation(intl, ProjectSetupTranslationKeys.editCompanySection)}
        isPosting={isPosting}
        onSubmit={releaseSubmitEvent}
        onCancel={onCancel}
      >
        <MemoLongCompanyForm
          disableInvolvement={disableInvolvement}
          sites={availableSites}
          isDialog={false}
          initialValues={existingValues}
        />
      </CompanyWizardPage>
    </WithInputForm>
  );
}

export const MemoEditCompanyWizardContainer = memo(
  composeHOCs(
    withProcessesData,
    withEditCompany,
    withCreateSite
  )(EditCompanyWizardContainer)
);
